import { CurriedGetDefaultMiddleware } from '@reduxjs/toolkit/src/getDefaultMiddleware'

import { campaignApi } from 'clickNgo/entities/campaign/api'
import { contactApi } from 'clickNgo/entities/contact/api'
import { contactFlagApi } from 'clickNgo/entities/contactFlag/api'
import { flagManagementApi } from 'clickNgo/entities/flagManagement/api/flagManagementApi'
import { partnerSpecializationApi } from 'clickNgo/entities/partner/api/partnerSpecializations'
import { promotionsApi } from 'clickNgo/entities/promotionProduct'
import { callHistoryApi } from 'clickNgo/features/callHistory'
import { campaignReminderApi } from 'clickNgo/features/campaign/emailReminder/api/campaignReminderApi'
import { formListenerMiddleware } from 'cng-common/features/form/listeners'
import { keyInitiativesApi } from 'partner360/entities/keyInitiatives'
import { masterDealerApi } from 'partner360/entities/masterDealer'
import { pbmCockpitApi } from 'partner360/entities/pbmCockpit'
import { pbmDashboardApi } from 'partner360/entities/pbmDashboard'
import { planFinancialsApi } from 'partner360/entities/planFinancials'
import { planningApi } from 'partner360/entities/planning'
import { espApi } from 'partner360/features/executiveSponsorProgram'
import { mdOffboardingApi } from 'partner360/features/mdOffboarding'

import { listenerMiddleware } from './listenerMiddleware'

export const middlewares = (getDefaultMiddleware: CurriedGetDefaultMiddleware) => {
  return getDefaultMiddleware({
    thunk: true,
    immutableCheck: false,
    serializableCheck: false,
  }).prepend([
    listenerMiddleware.middleware,
    formListenerMiddleware.middleware,
    contactApi.middleware,
    mdOffboardingApi.middleware,
    masterDealerApi.middleware,
    keyInitiativesApi.middleware,
    pbmCockpitApi.middleware,
    pbmDashboardApi.middleware,
    contactFlagApi.middleware,
    flagManagementApi.middleware,
    planFinancialsApi.middleware,
    planningApi.middleware,
    promotionsApi.middleware,
    espApi.middleware,
    campaignApi.middleware,
    campaignReminderApi.middleware,
    partnerSpecializationApi.middleware,
    callHistoryApi.middleware,
  ])
}
